export default __webpack_public_path__ + "static/media/16.81f210ef.jpg";